// extracted by mini-css-extract-plugin
module.exports = {"root":"PageContentWrapper_root__jBMJA","topBottomPadding":"PageContentWrapper_topBottomPadding__3BAeK"};